// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * PreviewContext - React context for triggering document analysis preview panel.
 *
 * Used by table cells (badges, buttons) to open the preview panel with analysis data.
 */
import { createContext } from 'react'

/** Payload for requesting a document preview */
export interface DocumentPreviewPayload {
  documentId: string
  targetId: string
  experience: string
  source: 'score' | 'details' | 'renderer'
  pipelineId?: string | null
  datasetKey?: string | null
  orgId?: string
  workspaceId?: string
  nodeInstanceId?: string | null
  title?: string
  subtitle?: string
  /** Document version being viewed */
  version?: number
  /** Latest version of the document */
  latestVersion?: number
}

export type DocumentPreviewRequest = (payload: DocumentPreviewPayload) => void

const DocumentPreviewContext = createContext<DocumentPreviewRequest>(() => {})

export function DocumentPreviewProvider({
  children,
  onPreview,
}: {
  children: React.ReactNode
  onPreview: DocumentPreviewRequest
}) {
  return (
    <DocumentPreviewContext.Provider value={onPreview}>
      {children}
    </DocumentPreviewContext.Provider>
  )
}
